<template>
    <div>
        <ly-dialog v-model="dialogVisible" :title="loadingTitle" width="640px" :before-close="handleClose">
            <el-form :inline="false" :model="formData" :rules="rules" ref="rulesForm" label-position="right" label-width="auto">
                <el-form-item label="用户名称：" prop="name">
                    <el-input v-model="formData.name"></el-input>
                </el-form-item>
                <el-form-item label="登陆账号：" prop="username">
                    <el-input v-model.trim="formData.username"></el-input>
                </el-form-item>
                <el-form-item label="登录密码：">
                    <el-input v-model.trim="formData.password" :show-password="true"></el-input>
                </el-form-item>
                <el-form-item label="角色：" prop="role">
                    <el-radio-group v-model="formData.role" @change="getRoleName">
                        <el-radio :label="item.id" v-for="(item,index) in rolelist" :key="index">{{item.name}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <!-- <el-form-item label="类型：" prop="type">
                    <el-radio-group v-model="formData.type">
                        <el-radio :label="0">无</el-radio>
                        <el-radio :label="1">伙伴</el-radio>
                        <el-radio :label="2">销售</el-radio>
                    </el-radio-group>
                </el-form-item> -->
                <el-form-item label="角色账号：" prop="account">
                    <el-select :key="roleName" v-model="formData.account" filterable clearable :disabled="roleName=='管理员'" style="width:100%">
                        <el-option 
                            v-for="(item,index) in roleName=='伙伴'?agentList:roleName=='销售'?saleList:roleName=='最终用户'?customerList:''" 
                            :key="(roleName=='伙伴'?item.agent_id:roleName=='最终用户'?item.id:item.name)" 
                            :label="(roleName=='伙伴'||roleName=='最终用户')?item.company:item.name" 
                            :value="roleName=='伙伴'?item.agent_id:roleName=='最终用户'?item.id:item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态：" prop="is_active">
                    <el-switch
                        v-model="formData.is_active"
                        active-color="#13ce66"
                        inactive-color="#ff4949">
                    </el-switch>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="handleClose" :loading="loadingSave">取消</el-button>
                <el-button type="primary" @click="submitData" :loading="loadingSave">确定</el-button>
            </template>
        </ly-dialog>
    </div>
</template>

<script>
    import {apiSystemUserAdd,apiSystemUserEdit,apiSystemRole,getAgentList,getSalesList,getCustomerList} from "@/api/api";
    import LyDialog from "../../../components/dialog/dialog";
    import md5 from 'js-md5'
    export default {
        components: {LyDialog},
        emits: ['refreshData'],
        name: "addAdmin",
        data() {
            const accountValidator=(rule, value, callback) => {
                if(this.roleName!='管理员'){
                    if(!value){
                        callback(new Error('角色账号不能为空！'))
                    }else{
                        callback()
                    }
                }else{
                    callback()
                }
            }
            return {
                dialogVisible:false,
                loadingSave:false,
                loadingTitle:'',
                formData:{
                    name:'',
                    type:'',
                    account:'',
                    username:'',
                    password:'',
                    role:[],
                    is_active:true
                },
                rules:{
                    name: [
                        {required: true, message: '请输入用户名称',trigger: 'blur'}
                    ],
                    role: [
                        {required: true, message: '请选择角色',trigger: 'blur'}
                    ],
                    username: [
                        {required: true, message: '请输入用户账号',trigger: 'blur'}
                    ],
                    is_active: [
                        {required: true, message: '请选择是否启用',trigger: 'blur'}
                    ],
                    account:[
                        {required: true, message: '请选择角色账号', validator:accountValidator}
                    ]
                },
                rolelist:[],
                options:[],
                agentList:[],
                saleList:[],
                customerList:[],
                roleName:'',
            }
        },
        methods:{
            handleClose() {
                this.dialogVisible=false
                this.loadingSave=false
                this.$emit('refreshData')
            },
            getRoleName(){
                this.rolelist.map(item=>{
                    if(item.id==this.formData.role){
                        this.roleName=item.name;
                        if(item.key=='admin'){
                            this.formData.type=1
                        }else if(item.key=='agent'){
                            this.formData.type=2
                        }else if(item.key=='sales'){
                            this.formData.type=3
                        }else{
                            this.formData.type=4
                        }
                    }
                })
            },
            addAdminFn(item,flag) {
                this.getapiSystemRole()
                this.getList1();
                this.getList2();
                this.getList3();
                this.loadingTitle=flag
                this.dialogVisible=true
                this.formData=item ? item : {
                    name:'',
                    username:'',
                    type:'',
                    account:'',
                    password:'',
                    role:[],
                    is_active:true
                }
                this.formData.role = item?item.role[0]:''
                var timer=setInterval(() => {
                    if(this.rolelist.length>0){
                        this.getRoleName();
                        clearInterval(timer);
                    }
                }, 500);
            },
            submitData() {
                this.$refs['rulesForm'].validate((valite)=>{
                    if(valite) {
                        this.loadingSave=true
                        let param = {
                            ...this.formData
                        }
                        if(param.role){
                            let rolearr = []
                            rolearr.push(param.role)
                            // for(var r in param.role){
                            //     rolearr.push(param.role[r])
                            // }
                            param.role = rolearr
                        }else{
                            param.role = []
                        }
                        if(this.formData.nickname=="" || this.formData.nickname== undefined || this.formData.nickname.length<=0 || this.formData.nickname=='""'){
                            param.nickname = this.formData.name
                        }
                        param.dept='d2c03bd9-dad0-4262-88ca-c3681d224fc3';
                        if(param.password){
                            param.password=md5(param.password);
                        }
                        if(this.formData.id){
                            apiSystemUserEdit(param).then(res=>{
                                this.loadingSave=false
                                if(res.code ==2000) {
                                    this.$message.success(res.msg)
                                    this.handleClose()
                                    this.$emit('refreshData')
                                } else {
                                    this.$message.warning(res.msg)
                                }
                            })
                        }else{
                            apiSystemUserAdd(param).then(res=>{
                                this.loadingSave=false
                                if(res.code ==2000) {
                                    this.$message.success(res.msg)
                                    this.handleClose()
                                    this.$emit('refreshData')
                                } else {
                                    this.$message.warning(res.msg)
                                }
                            })
                        }

                    }
                })
            },
            getapiSystemRole(){
                apiSystemRole({page:1,limit:999}).then(res=>{
                    if(res.code ==2000) {
                        this.rolelist = res.data.data
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
            },
            getList1(){
                getAgentList({company:'',payers:'',sales:'',page:1,limit:99999}).then(res=>{
                    if(res.code==2000){
                        this.agentList=res.data.data;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            getList2(){
                getSalesList({name:'',phone:'',page:1,limit:99999}).then(res=>{
                    if(res.code==2000){
                        this.saleList=res.data.data;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            getList3(){
                getCustomerList({page:1,limit:99999}).then(res=>{
                    if(res.code==2000){
                        this.customerList=res.data.data;
                        this.customerList.forEach(el=>{
                            el.id = el.id.toString()
                        })
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            roleChange(){
                this.formData.type=0;
                this.formData.account=''
            }
        }
    }
</script>

